import React from 'react';

export const CodeblockFlexItem = ({ cssProp, currentValueSelect, dispatch, itemId }) => {
  

  if (cssProp) {
    return (
      <div className="codeblock-style">

        <span className="property-name">{cssProp.propertyName} : </span>
        {
          cssProp.propertyValue.map((i, j) =>
            <span key={j} >
              
              <span 
                className={ currentValueSelect === i ? 'currentValueSelect' : ''}
                onClick={ () => {
                  dispatch({
                    type: cssProp.propertyName,
                    payload: {
                      itemId,
                      value: i
                    }
                  })
                }}
              >{i}</span>
              
              <span> {j + 1 === cssProp.propertyValue.length ? '' : '|'} </span>  
              {/* this adds the | or ; to the right of each value */}

            </span>
          )
        }



      </div>
    );
  } else {
    return null;
  }
}



const Codeblock = ({ cssProp, currentValueSelect, dispatch }) => {

  if (cssProp) {
    return (
      <div className="codeblock-style">

        <span className="property-name">{cssProp.propertyName} : </span>
        {
          cssProp.propertyValue.map((i, j) =>
            <span key={j} >
              
              <span 
                className={ currentValueSelect === i ? 'currentValueSelect' : ''}
                onClick={ () => {
                  dispatch({
                    type: cssProp.propertyName,
                    payload: i
                  })
                }}
              >{i}</span>
              
              <span> {j + 1 === cssProp.propertyValue.length ? ';' : '|'} </span>  
              {/* this adds the | or ; to the right of each value */}

            </span>
          )
        }



      </div>
    );
  } else {
    return null;
  }
}

export default Codeblock;



// ------------------------------- Notes --------------------

//  cssProp = {
//    propertyName: 'display',
//    propertyValue: ['block', 'flex'],
//    defaultPropertyValue: 'block'
//  }